export default "__VITE_ASSET__CHHVcKJ9__"